import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { brandlogo } from "../../assets";
import styles from "./footer.module.css";
import InitialCard from "../common/InitialCard";
import Skeleton from "react-loading-skeleton";

const currentYear = new Date().getFullYear();

const BrandedFooter = ({ organisation, storePath, isSwitching }) => {
  const ExpandableText = ({ text }) => {
    const [expanded, setExpanded] = useState(false);

    return (
      <p
        className={`${styles.footerdescription} ${
          expanded ? styles.expanded : ""
        }`}
        onClick={() => setExpanded(!expanded)}
      >
        {text}
      </p>
    );
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerwrapper}>
        {storePath === "market-place" ? (
          <>
            <div className={styles.footerleft} style={{ padding: "4rem 2rem" }}>
              <div className={styles.circlebrand}>
                {/* <div className={styles.desc_year}>
                  <p className={styles.footerdesc}>StoreFront Powered By</p>
                </div> */}
                <Link href={"/"}>
                  <div className={styles.brandImagecontainer}>
                    <Image
                      src={brandlogo}
                      alt="circle plug brand logo"
                      className={styles.brandlogo}
                      quality={1}
                    />
                  </div>
                </Link>
                <div className={styles.desc_year}>
                  <p className={styles.footerdesc}>
                    Connecting buyers and sellers, one deal at a time.
                  </p>
                  <p className={styles.footeryear}>
                    &copy; Copyright {currentYear}
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.footerright}></div>
          </>
        ) : (
          <>
            {/* <div className={styles.footerleft}>
              <div className={styles.topimageinitials}>
                <InitialCard
                  image={organisation?.logoUrl ?? ""}
                  name={organisation?.orgName ?? ""}
                />
                <div>
                  <div className={styles.brandName}>
                    {organisation?.orgName ?? ""}
                  </div>
                  <div className={styles.storeFront}>
                    {organisation?.settings?.storeName || "StoreFront"}
                  </div>
                </div>
              </div>
              <div className={styles.desc_year}>
                <ExpandableText text={organisation?.description ?? ""} />
              </div>
              <div className={styles.desc_year}>
                <ExpandableText text={organisation?.address ?? ""} />
              </div>
              <div className={styles.desc_year}>
                <p className={styles.footerdesc}>
                  {organisation?.fullPhone ?? ""}
                </p>
              </div>
            </div> */}

            <div className={styles.footerleft}>
              <div className={styles.topimageinitials}>
                {isSwitching ? (
                  <>
                    <div
                      style={{
                        width: "5rem",
                        height: "5rem",
                        borderRadius: "50%",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <Skeleton circle height={"5rem"} width={"5rem"} />
                    </div>
                    <div>
                      <div className={styles.brandName}>
                        <Skeleton width={150} height={20} />
                      </div>
                      <div className={styles.storeFront}>
                        <Skeleton width={120} height={16} />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <InitialCard
                      image={organisation?.logoUrl ?? ""}
                      name={organisation?.orgName ?? ""}
                    />
                    <div>
                      <div className={styles.brandName}>
                        {organisation?.orgName ?? ""}
                      </div>
                      <div className={styles.storeFront}>
                        {organisation?.settings?.storeName || "StoreFront"}
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className={styles.desc_year}>
                {isSwitching ? (
                  <Skeleton width={"100%"} height={20} />
                ) : (
                  <ExpandableText text={organisation?.description ?? ""} />
                )}
              </div>
              <div className={styles.desc_year}>
                {isSwitching ? (
                  <Skeleton width={"100%"} height={20} />
                ) : (
                  <ExpandableText text={organisation?.address ?? ""} />
                )}
              </div>
              <div className={styles.desc_year}>
                {isSwitching ? (
                  <Skeleton width={120} height={16} />
                ) : (
                  <p className={styles.footerdesc}>
                    {organisation?.fullPhone ?? ""}
                  </p>
                )}
              </div>
            </div>

            <div className={styles.footerright}>
              <div className={styles.circlebrand}>
                <div className={styles.desc_year}>
                  <p className={styles.footerdesc}>StoreFront Powered By</p>
                </div>
                <Link href={"/"}>
                  <div className={styles.brandImagecontainer}>
                    <Image
                      src={brandlogo}
                      alt="circle plug brand logo"
                      className={styles.brandlogo}
                      quality={1}
                    />
                  </div>
                </Link>
                <div className={styles.desc_year}>
                  <p className={styles.footeryear}>
                    &copy; Copyright {currentYear}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </footer>
  );
};

export default BrandedFooter;
